var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50008 6.08492L1.41508 3.99992L0.705078 4.70492L3.50008 7.49992L9.50008 1.49992L8.79508 0.794922L3.50008 6.08492Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck24Px);
export default __webpack_public_path__ + "static/media/check_24px.8f22f55afc930c26f297f5a89942d72c.svg";
export { ForwardRef as ReactComponent };